import { useTranslation } from "react-i18next";
import type { ClientBrainAction } from "./models";
export function BrainActionSummary({ action }: { action?: ClientBrainAction | null }) {
    const { t } = useTranslation();
    if (!action) return null;
    return <section><strong>{t("clientBrainAction.title", { defaultValue: "Client Brain changes" })}</strong><p>{action.instructions}</p>{action.allow_goal_status_changes && <p>{t("clientBrainAction.goals", { defaultValue: "Allow goal status changes" })}</p>}<small>{t("clientBrainAction.configurationHelp", { defaultValue: "Execution shows proposed changes and uses this step’s Sign settings and Project modify permission." })}</small></section>;
}
